module.exports = __webpack_public_path__ + "img/contabilidad.e3ef4314.png";